// extracted by mini-css-extract-plugin
export default {"SignContract":"SignContract_SignContract__FgNiY","Details":"SignContract_Details__4e85P","ButtonBox":"SignContract_ButtonBox__gBIRh"};